import { render, staticRenderFns } from "./LogcDialog.vue?vue&type=template&id=fd151d84"
import script from "./LogcDialog.vue?vue&type=script&lang=js"
export * from "./LogcDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports